import { render, staticRenderFns } from "./AddPersonCharge.vue?vue&type=template&id=dd1c5448&scoped=true"
import script from "./AddPersonCharge.vue?vue&type=script&lang=js"
export * from "./AddPersonCharge.vue?vue&type=script&lang=js"
import style0 from "./AddPersonCharge.vue?vue&type=style&index=0&id=dd1c5448&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd1c5448",
  null
  
)

export default component.exports